import { ReactNode } from "react";
import { PopoverProps, MenuProps } from "react-aria-components";
import cx from "classnames";

import DropdownMenu from "ds/components/DropdownMenu";

import styles from "./styles.module.css";

export type MainNavigationDropdownMenuProps = {
  dropdownId: string;
  children: ReactNode;
  triggerComponent: ReactNode;
  placement?: PopoverProps["placement"];
  className?: string;
  isOpen: boolean;
} & Omit<MenuProps<object>, "onSelectionChange">;

const MainNavigationDropdownMenu = ({
  children,
  triggerComponent,
  placement = "right bottom",
  className,
  isOpen,
  dropdownId,
  ...menuProps
}: MainNavigationDropdownMenuProps) => {
  return (
    <DropdownMenu
      id={dropdownId}
      placement={placement}
      isOpen={isOpen}
      triggerComponent={triggerComponent}
      className={cx(styles.menu, className)}
      isNonModal
      {...menuProps}
    >
      {children}
    </DropdownMenu>
  );
};

export default MainNavigationDropdownMenu;
